module.exports = "/images/RR.png?440cb807f9e4347723583095cef430f8";